import { useState, useEffect } from 'react';
import styles from './CookieConsent.module.css';
import {Link} from "react-router-dom";

export const CookieConsent = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setVisible(true);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem('cookieConsent', 'true');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className={styles.cookieConsent}>
            <div className={styles.content}>
                <div className={styles.textContainer}>
                    <p className={styles.text}>
                        Мы используем файлы cookies для улучшения работы сайта.
                        Продолжая использовать сайт, вы соглашаетесь с обработкой персональных данных, <a href={'/privacy'}>политикой
                        конфиденциальности</a> и <a href={'/eula'}> пользовательским соглашением</a>
                    </p>
                </div>
                <button className={styles.acceptButton} onClick={acceptCookies}>Принять</button>
            </div>
        </div>
    );
};